import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../_metronic/_partials/controls";
import { formatAmount, formatDate, formatStatus, permissionCssClass } from "../../../../util/Helpers";
import { useSelector } from "react-redux";
import { SubHeader } from "../../../Common/layout/SubHeader";
import { Link, Redirect, Switch } from "react-router-dom";
import SimpleTable from "my-simple-react-table";
import { ContentRoute } from "../../../../../_metronic/layout";
import { Permissions, PermissionType } from "../../../../util/Permissions";
import ViewSafeLockModal from "../../../UserManagement/pages/selected-user/view-user/user-pages/safe-locks/modal/ViewSafeLockModal";
import { useDownloadSafeLockReportMutation, useGetDisabledPlansQuery, useGetSafeLockPlansQuery, useUpdateSafeLockStatusMutation } from "../../../../../redux/apiSlice";
import { errorMessage } from "../../../../util/Helpers";
import TableSkeleton from "../../../../util/TableSkeleton";
import { EditPlanModal } from "../../../SafeLockManagement/pages/edit-plan/EditPlanModal";
import EnablePlanModal from "../../../SafeLockManagement/pages/modals/EnablePlanModal";
import DisablePlanModal from "../../../SafeLockManagement/pages/modals/DisablePlanModal";
import { UpdateEarnStatusModal } from "../../../SafeLockManagement/pages/modals/UpdateEarnStatusModal";
import { FilterGroup } from "../../../Common/components/FilterGroup";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { Permission } from "../../../Common/layout/Permission";
import SafeLockLiquidations from "./safeLockLiquidations";




const Plans = () => {

    const adminUser = useSelector(state => state.auth.user);



    const { isGetting, data: plans } = useGetSafeLockPlansQuery()
    const { isDisabled, data: disabledPlans } = useGetDisabledPlansQuery()
    const [
        updateSafeLockStatus,
        { isLoading: isUpdatingStatus }
    ] = useUpdateSafeLockStatusMutation();

    /* Safe Lock Edit Plan State Management */
    const [showEditPlanModal, setShowPlanModal] = useState({ showEditPlanModal: false, planDetails: null });

    /* Safe Lock Modal State Management */
    const [safeLockedModal, setsafeLockedModal] = useState({ showViewSafeLockModal: false, details: null });

    const [showEnablePlanModal, setEnablePlanModal] = useState({ showEnablePlanModal: false, disabledPlanDetails: null });

    const [showDisablePlanModal, setDisablePlanModal] = useState({ showDisablePlanModal: false, planDetails: null });
    const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setsafeLockedModal({ ...safeLockedModal, [modal]: !safeLockedModal[modal] })
    }
    const NewtoggleModal = modal => _ => {
        setShowPlanModal({ ...showEditPlanModal, [modal]: !showEditPlanModal[modal] })
    }


    const togglePlanModal = modal => _ => {
        setEnablePlanModal({ ...showEnablePlanModal, [modal]: !showEnablePlanModal[modal] })
    }
    const toggleDisablePlanModal = modal => _ => {
        setDisablePlanModal({ ...showDisablePlanModal, [modal]: !showDisablePlanModal[modal] })
    }



    // Action Butons
    const actionButtonsafe = row => {

        return <span style={{ whiteSpace: "nowrap" }}>
            <button
                className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                onClick={_ => viewSafeLockDetails(row)}
            >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG
                        title="View payment"
                        src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                    />
                </span>
            </button>
        </span>
    }
    const actionButtonplan = row => {

        return <span style={{ whiteSpace: "nowrap" }}>
            <span style={{ whiteSpace: "nowrap" }}>
                <button
                    onClick={_ => viewPlanDetails(row.planId)}
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.BANKS, PermissionType.UPDATE)}`}
                    disabled={row.isEnabled === true}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            title="Edit Plan"
                            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                        />
                    </span>
                </button>
                <Button
                    title="Enable Plan"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.CARDS, PermissionType.UPDATE)}`}
                    onClick={_ => enablePlanDetails(row.planId)}
                    disabled={row.isEnabled === false}

                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            title="Enable Plan"
                            src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                        />
                    </span>
                </Button>
                <Button
                    title="Disabled Plan"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.CARDS, PermissionType.UPDATE)}`}
                    onClick={_ => disablePlanDetails(row.planId)}
                    disabled={row.isEnabled === true}

                >
                    <span className={`svg-icon svg-icon-md svg-icon-danger`}>
                        <SVG
                            title="Disable Plan"
                            src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                        />
                    </span>
                </Button>
            </span>
        </span>
    }

    /* View Order Details */
    const viewSafeLockDetails = details => {
        setsafeLockedModal({ ...safeLockedModal, showViewSafeLockModal: true, details });
    }


    // View Plan Details
    const viewPlanDetails = planId => {
        const planDetails = plans.responseData.filter(plan => planId === plan.planId)[0];
        setShowPlanModal({ ...showEditPlanModal, showEditPlanModal: true, planDetails });
    }

    const enablePlanDetails = planId => {
        const disabledPlanDetails = disabledPlans.responseData.filter(disabledPlan => planId === disabledPlan.planId)[0];
        setEnablePlanModal({ ...showEnablePlanModal, showEnablePlanModal: true, disabledPlanDetails });

    }

    const disablePlanDetails = planId => {
        const planDetails = plans.responseData.filter(plan => planId === plan.planId)[0];
        setDisablePlanModal({ ...showDisablePlanModal, showDisablePlanModal: true, planDetails });

    }
    const tableRefSafeLocks = useRef();


    const [
        downloadSafeLockReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadSafeLockReportMutation()

    useEffect(() => {
        if (errorReport) {
            cogoToast.error(errorReport.data);
        }
    }, [errorReport])

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`Safe Lock export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    const renderEmail = (emailAddr) => {
        const truncatedEmail = emailAddr?.slice(0, 6) + "...";

        const handleCopy = () => {
            navigator.clipboard.writeText(emailAddr);
            cogoToast.success("Email copied to clipboard!");
        };

        return (
            <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
                <span title={emailAddr} style={{ cursor: "pointer" }}>
                    {truncatedEmail}
                </span>
                <span
                    onClick={handleCopy}
                    title="Copy Email"
                    style={{
                        cursor: "pointer",
                        color: "green",
                        fontSize: "12px",
                        fontWeight: "bold",
                    }}
                >
                    📋
                </span>
            </div>
        );
    };




    return <>
        <SubHeader>
            <SubHeader.Nav>
                <SubHeader.NavItem label={"Safe Locks"} to={`/overview/safeplans/safelocks`} />
                <SubHeader.NavItem label={"Liquidations"} to={`/overview/safeplans/liquidations`} />
                <SubHeader.NavItem label={"Safe Lock Plans"} to={`/overview/safeplans/plans`} />
                <SubHeader.NavItem label={"Disabled Plans"} to={`/overview/safeplans/disabled`} />
            </SubHeader.Nav>
        </SubHeader>
        <div className="py-4 px-6">

            <Switch>
                <Redirect exact={true} from="/overview/safeplans" to="/overview/safeplans/safelocks" />

                <ContentRoute
                    exact
                    path="/overview/safeplans/safelocks"
                    permission={Permissions.SAFE_LOCK}
                >


                    <div className="py-4 px-6 flex">

                        <FilterGroup
                            defaultFilters={{ endDate: new Date().toISOString().split('T')[0] }}>


                            <FilterGroup.DateRange className={"mb-4"} />
                            <div className="d-flex">
                                <div className={"mb-4 mr-4"}>
                                    <FilterGroup.Filter className={"mr-4"} name={"planId"} label={"Plan Type"}>
                                        <FilterGroup.Option value={"4f2a4bd9-2a08-46d5-85b3-589e414c4754"}>12 Months Plan (Naira)</FilterGroup.Option>
                                        <FilterGroup.Option value={"ae02016a-0190-4e4d-9eea-cdec5071680b"}>12 Months Plan (Dollars)</FilterGroup.Option>
                                        <FilterGroup.Option value={"2504faa3-a5d0-4646-8834-5324816c1d4f"}>9 Months Plan (Naira)</FilterGroup.Option>
                                        <FilterGroup.Option value={"4989e0cc-60e2-40e5-85b1-69b5d764b0d4"}>9 Months Plan (Dollar)</FilterGroup.Option>
                                        <FilterGroup.Option value={"0d3313a4-7f84-4c5c-b8a5-b5722db28755"}>6 Months Plan (Naira)</FilterGroup.Option>
                                        <FilterGroup.Option value={"2fa52a85-cd23-405f-b12f-f37468726947"}>6 Months Plan (Dollar)</FilterGroup.Option>
                                        <FilterGroup.Option value={"857d9a75-30c4-4ed5-a019-83aca75cc6eb"}>3 Months Plan (Naira)</FilterGroup.Option>
                                        <FilterGroup.Option value={"4e05babc-0b27-4e9d-8361-c1527c5e32e8"}>3 Months Plan (Dollar)</FilterGroup.Option>


                                    </FilterGroup.Filter>
                                </div>
                                <div className={"mb-4 mr-4"}>
                                    <FilterGroup.Filter className={"mr-4"} name={"status"} label={"Status"}>
                                        <FilterGroup.Option value={""}>All</FilterGroup.Option>
                                        <FilterGroup.Option value={"successful"}>Successful</FilterGroup.Option>
                                        <FilterGroup.Option value={"abandoned"}>Abandoned</FilterGroup.Option>


                                    </FilterGroup.Filter>
                                </div>
                            </div>


                            <FilterGroup.Content>
                                {
                                    ({ filters }) => {
                                        return <Card>
                                            <CardHeader title="Safe Lock List">

                                                <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                                                    <CardHeaderToolbar>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary mr-3"
                                                            onClick={() => setShowUpdateStatusModal(true)}
                                                        >
                                                            Update Status
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            disabled={isLoadingReport}
                                                            onClick={() => downloadSafeLockReport({
                                                                startDate: filters?.startDate || "",
                                                                endDate: filters?.endDate || "",
                                                                status: filters?.status || "",
                                                                format: "csv",
                                                            })}
                                                        >
                                                            Export CSV
                                                        </button>
                                                    </CardHeaderToolbar>
                                                </Permission>
                                            </CardHeader>
                                            <DynamicSimpleTable
                                                queryParams={
                                                    `&startDate=${filters?.startDate || ""}`
                                                    + `&endDate=${filters?.endDate || ""}`
                                                    + `&planId=${filters?.planId || ""}`
                                                    + `&status=${filters?.status || ""}`

                                                }
                                                searchBox={false}
                                                source={{ url: `/safe-lock` }}
                                                columns={[
                                                    { title: "Tenure", key: "tenor" },
                                                    { title: "Tenure Left", key: "tenorleftover" },
                                                    { title: "Customer Name", key: "customerName" },

                                                    {
                                                        title: "Email",
                                                        key: "email",
                                                        format: (row) => renderEmail(row.emailAddr),
                                                    },
                                                    { title: "Transaction Reference", format: (row) => (row.safelockDeposits[0].tranRef) },
                                                    { title: "Maturity Date", format: (row) => formatDate(row.safelockDeposits[0].maturityDate) },
                                                    { title: "Amount Locked", format: (row) => formatAmount(row.currency, row.safelockDeposits[0].deposit) },
                                                    { title: "Rate%", key: "rate" },
                                                    { title: "Interest Earned", format: (row) => formatAmount(row.currency, row.safelockDeposits[0].interestEarned) },
                                                    { title: "Payback Amount", format: (row) => formatAmount(row.currency, (row.safelockDeposits[0].deposit) + ((row.currency, row.safelockDeposits[0].interestEarned))) },
                                                    { title: "Date Created", format: (row) => formatDate(row.safelockDeposits[0].createdAt) },
                                                    { title: "Status", format: (row) => formatStatus(row.safelockDeposits[0].paymentStatus) },
                                                    { title: "", format: actionButtonsafe }

                                                ]}
                                                ref={tableRefSafeLocks}
                                                refreshIcon={true}

                                            />


                                        </Card>
                                    }
                                }
                            </FilterGroup.Content>
                        </FilterGroup>
                    </div>

                </ContentRoute>

                <ContentRoute path="/overview/safeplans/plans" permission={Permissions.SAFE_LOCK}>
                    <Card>
                        <CardHeader title="Safe Lock Plans">
                            <CardHeaderToolbar>
                                <Link
                                    to={"/overview/safeLocks/create"}
                                    className={`btn btn-primary ${permissionCssClass(adminUser, Permissions.SAFE_LOCK, PermissionType.CREATE)}`}
                                >
                                    Create Plan
                                </Link>

                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody>
                            {isGetting ? (
                                <TableSkeleton />
                            ) : (
                                <SimpleTable
                                    data={plans?.responseData || []}
                                    columns={[
                                        { title: "Plan Name", key: "planName" },
                                        { title: "Plan ID", key: "planId" },
                                        { title: "Plan Description", key: "planDescription" },
                                        { title: "Tenure", key: "tenor" },
                                        { title: "Rate", key: "rate" },
                                        { title: "T Plus Days", key: "tPlusDays" },
                                        { title: "Minimum Amount", format: (row) => formatAmount(row.currency, row.minimumAmount) },
                                        { title: "Maximum Amount", format: (row) => formatAmount(row.currency, row.maximumAmount) },
                                        { title: "", format: actionButtonplan }
                                    ]}
                                />
                            )}
                        </CardBody>
                    </Card>
                </ContentRoute>
                <ContentRoute path="/overview/safeplans/disabled" permission={Permissions.SAFE_LOCK}>

                    <Card>
                        <CardHeader title="Disabled Plans">
                            <CardHeaderToolbar>
                                <Link
                                    to={"/overview/safeLocks/create"}
                                    className={`btn btn-primary ${permissionCssClass(adminUser, Permissions.SAFE_LOCK, PermissionType.CREATE)}`}
                                >
                                    Create Plan
                                </Link>

                            </CardHeaderToolbar>

                        </CardHeader>
                        <CardBody>
                            {isDisabled ? (
                                <TableSkeleton />
                            ) : (
                                <SimpleTable
                                    data={disabledPlans?.responseData || []}
                                    columns={[
                                        { title: "Plan Name", key: "planName" },
                                        { title: "Plan ID", key: "planId" },
                                        { title: "Plan Description", key: "planDescription" },
                                        { title: "Tenure", key: "tenor" },
                                        { title: "Rate", key: "rate" },
                                        { title: "Minimum Amount", format: (row) => formatAmount(row.currency, row.minimumAmount) },
                                        { title: "Minimum Amount", format: (row) => formatAmount(row.currency, row.maximumAmount) },
                                        { title: "", format: actionButtonplan }
                                    ]}
                                />
                            )}
                        </CardBody>
                    </Card>

                </ContentRoute>
                <ContentRoute path="/overview/safeplans/liquidations" permission={Permissions.SAFE_LOCK}>
                    <SafeLockLiquidations />
                </ContentRoute>

            </Switch>

        </div>
        <ViewSafeLockModal {...safeLockedModal} onHide={toggleModal("showViewSafeLockModal")} />
        <EditPlanModal {...showEditPlanModal} onHide={NewtoggleModal("showEditPlanModal")} />
        <EnablePlanModal {...showEnablePlanModal} onHide={togglePlanModal("showEnablePlanModal")} />
        <DisablePlanModal {...showDisablePlanModal} onHide={toggleDisablePlanModal("showDisablePlanModal")} />
        <UpdateEarnStatusModal
            show={showUpdateStatusModal}
            onHide={() => setShowUpdateStatusModal(false)}
        />

    </>
};

export default Plans;
